import React from "react";
import { Shield } from "lucide-react";

export default function Navbar() {
  const handleNavClick = (e, targetId) => {
    if (window.location.pathname === "/") {
      e.preventDefault();
      const elem = document.getElementById(targetId);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
        window.history.pushState(null, "", `/#${targetId}`);
      }
    }
  };

  return (
    <header className="tfl-nav" aria-label="Global">
      <nav className="tfl-nav__inner">
        {/* Brand */}
        <a href="/" className="tfl-nav__brand">
          <div className="tfl-nav__brand-icon">
            <Shield size={16} color="#ffffff" />
          </div>
          <span>ThreatForge</span>
        </a>

        {/* Nav links */}
        <ul className="tfl-nav__links" role="list">
          <li><a href="/#features" onClick={(e) => handleNavClick(e, "features")}>Features</a></li>
          <li><a href="/#methodology" onClick={(e) => handleNavClick(e, "methodology")}>Methodology</a></li>
          <li><a href="/#about" onClick={(e) => handleNavClick(e, "about")}>About</a></li>
          <li><a href="/#pricing" onClick={(e) => handleNavClick(e, "pricing")}>Pricing</a></li>
        </ul>

        {/* Actions */}
        <div className="tfl-nav__actions">
          <a href="/login" className="tfl-nav__login">
            <span>Sign In</span>
          </a>
          <a href="/get-quote" className="tfl-btn tfl-btn--primary">
            <span>Get Quote</span>
          </a>
          <a href="/book-demo" className="tfl-btn tfl-btn--ghost">
            <span>Book a Demo</span>
          </a>
        </div>
      </nav>
    </header>
  );
}
